import {
  Card,
  CardContent,
  Typography,
  makeStyles,
  Grid,
  Tooltip,
} from "@material-ui/core";
import {
  ABROAD_BIRTH_PLACE_ID,
  GR_CODE_CRIMINAL,
  NEW_NAUTICAL_APPLICATION,
} from "../../../constants";

import { useField, useFormikContext } from "formik";

import useLocale from "../../../hooks/useLocale";

import { educationLevel } from "../../../constants";

import { useCallback, useEffect } from "react";
import GovGrTextField from "../../../components/GovGrTextField";
import { fetchPrfcsForExternalUser } from "../../../services/prfcsService";
import { useQuery } from "react-query";
import { fetchPortAuthoritiesForExternalUser } from "../../../services/portAuthoritiesService";
import CheckBoxesForCustomText from "./CheckBoxesForCustomText";
import GovGrDate from "../../../components/GovGrDate";
import GovGrSelectBox from "../../../components/GovGrSelectBox";

import { fetchDidacticYears } from "../../../services/gatewayDataTables";
import { useMemo } from "react";
import { fetchBirthCountry } from "../../../services/birthCountryService";
import ls from "local-storage";
import { useDispatch, useSelector } from "react-redux";
import { updateUserPorthAuth } from "../../../redux/actions/authActions";

const useStyles = makeStyles({
  root: {
    "& .MuiTextField-root": {
      margin: 15,
    },
  },
  card: {
    minWidth: 275,
    marginTop: 15,
    marginBottom: 15,
    alignSelf: "center",
  },
  fieldsContent: {
    display: "inline-flex",
  },
  fieldMargin: {
    marginLeft: "2rem",
  },
  autoComplete: {
    width: 225,
    // maxWidth: 221,
    display: "inline-block",
    marginRight: "30px",
  },
});

const ApplicantDetails = ({
  forMe,
  portAuthId,
  disableAll,
  translatedGender,
  AMKAfieldIsEnabled,
}) => {
  const { values, touched } = useFormikContext();
  const { t } = useLocale();
  const classes = useStyles();
  const portField = useField("portAuthority");
  const dimosField = useField("dimos_diamonis_afora");
  const afm = useField("afm_afora");
  const user = useSelector((state) => state.authReducer?.user);
  const dispatch = useDispatch();

  const { data: fetchBirthCountries } = useQuery(
    "fetchBirthCountries",
    fetchBirthCountry
  );

  const TranslatedEducationLevel = educationLevel.map((option) => {
    return { id: option.id, dscr: t(`${option.dscr}`) };
  });

  //Check if the application is New Nautical and return true or false to hide the extra fields
  const checkNewNautical = () => {
    if (parseInt(values?.appl_kind_id) === parseInt(NEW_NAUTICAL_APPLICATION)) {
      return true;
    } else {
      return false;
    }
  };

  // function that takes a fieldname and a map and returns boolean
  // it is used to check if the field should be disabled or not
  const isFieldDisabled = useCallback((fieldName, disabledMap) => {
    if (!disabledMap) {
      return false;
    }

    return disabledMap?.[fieldName];
  }, []);

  const { data: PrfcsData } = useQuery("prfcs", fetchPrfcsForExternalUser);
  const { data: PortAuthoritiesData } = useQuery(
    "portAuthorities",
    fetchPortAuthoritiesForExternalUser
  );

  const { data: DidacticYears } = useQuery("didacticYears", fetchDidacticYears);

  const didacticyearWithOtherOption = useMemo(() => {
    if (DidacticYears && DidacticYears[0]?.id !== -10) {
      DidacticYears?.unshift({ id: -10, dscr: "Άλλο Διδακτικό Έτος" });
    }
    return DidacticYears;
  }, [DidacticYears]);

  useEffect(() => {
    if (PortAuthoritiesData) {
      const portAuth = PortAuthoritiesData?.find(
        (p) => p.id == dimosField?.[0]?.value?.pauthId
      );
      if (portAuth) {
        portField[2].setValue(portAuth);
      }
    }
  }, [dimosField?.[0].value]);

  return (
    <>
      <div className={classes.root}>
        <Card className={classes.card} raised={true}>
          <CardContent>
            <Typography variant="h4" color="textSecondary" gutterBottom>
              {t("Application Details")}
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrSelectBox
                  disabled={
                    disableAll ||
                    isFieldDisabled(
                      "port_auth_id",
                      values?.disabledConfiguration
                    )
                  }
                  name="portAuthority"
                  label={t("Port Authority")}
                  options={PortAuthoritiesData || []}
                  optionlabel="dscr"
                  defaultoptiontext={t("Choose Here")}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              {/* <div className={classes.fieldMargin}> */}
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="applicationKind"
                  margin="normal"
                  disabled
                  label={t("Application Kind")}
                  className="mr-5"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  style={{ width: 460 }}
                  variant="outlined"
                  name="sector"
                  margin="normal"
                  disabled
                  label={t("Sector")}
                  className="mr-1"
                />
              </Grid>
            </Grid>
          </CardContent>
          <Card className={classes.card} raised={true}>
            <CardContent>
              <Typography variant="h4" color="textSecondary" gutterBottom>
                {t("Pickup place")}
              </Typography>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrSelectBox
                  // disabled={false} //{disableAll}
                  disabled={disableAll}
                  name="pickup_place"
                  label={t("Port Authority")}
                  options={PortAuthoritiesData || []}
                  optionlabel="dscr"
                  defaultoptiontext={t("Choose Here")}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
            </CardContent>
          </Card>
        </Card>
        {!forMe && (
          <Card className={classes.card} raised={true}>
            <CardContent>
              <Typography variant="h4" color="textSecondary" gutterBottom>
                {t("Your information")}
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="lname_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled("lname", values?.disabledConfiguration))
                    }
                    label={t("Surname")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="fname_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled("fname", values?.disabledConfiguration))
                    }
                    label={t("Name")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    variant="outlined"
                    name="afm_ait"
                    margin="normal"
                    disabled={disableAll || !forMe}
                    label={t("AFM")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="ind_nr_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled(
                          "ind_nr",
                          values?.disabledConfiguration
                        ))
                    }
                    label={t("ADT")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="amka_ait"
                    margin="normal"
                    label={t("AMKA")}
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled("amka", values?.disabledConfiguration))
                    }
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    variant="outlined"
                    name="meth_ait"
                    margin="normal"
                    label={t("Meth")}
                    disabled={checkNewNautical() || disableAll}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="fath_lname_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled(
                          "fath_lname",
                          values?.disabledConfiguration
                        ))
                    }
                    label={t("Father Surname")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="fath_fname_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled(
                          "fath_fname",
                          values?.disabledConfiguration
                        ))
                    }
                    label={t("Father Name")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="address_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled(
                          "address",
                          values?.disabledConfiguration
                        ))
                    }
                    label={t("Address")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="address_nr_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled(
                          "address_nr",
                          values?.disabledConfiguration
                        ))
                    }
                    label={t("Address Number")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="tk_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled("tk", values?.disabledConfiguration))
                    }
                    label={t("TK")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="tel_ait"
                    margin="normal"
                    disabled={
                      disableAll ||
                      (!forMe &&
                        isFieldDisabled("tel", values?.disabledConfiguration))
                    }
                    label={t("Phone Number")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
                <Tooltip
                  title={
                    <Typography>
                      {t(
                        "In the case that information you see is not correct, please update your info"
                      )}
                    </Typography>
                  }
                  placement="center-bottom"
                >
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                    <GovGrTextField
                      required
                      variant="outlined"
                      name="mobile_ait"
                      margin="normal"
                      disabled={
                        disableAll ||
                        (!forMe &&
                          isFieldDisabled(
                            "mobile",
                            values?.disabledConfiguration
                          ))
                      }
                      label={t("Mobile Phone Number")}
                      disabledmessage={t("Field can't be edited")}
                    />
                  </Grid>
                </Tooltip>
                <Tooltip
                  title={
                    <Typography>
                      {t(
                        "In the case that information you see is not correct, please update your info"
                      )}
                    </Typography>
                  }
                  placement="center-bottom"
                >
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                    <GovGrTextField
                      required
                      variant="outlined"
                      name="email_ait"
                      margin="normal"
                      disabled={
                        disableAll ||
                        (!forMe &&
                          isFieldDisabled(
                            "email",
                            values?.disabledConfiguration
                          ))
                      }
                      label={t("Email")}
                      disabledmessage={t("Field can't be edited")}
                    />
                  </Grid>
                </Tooltip>
              </Grid>
            </CardContent>
          </Card>
        )}

        <Card className={classes.card} raised={true}>
          <CardContent>
            <Typography variant="h4" color="textSecondary" gutterBottom>
              {!forMe
                ? t("Information of the person you are applying for")
                : t("Your information")}
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="lname_afora"
                  margin="normal"
                  required
                  label={t("Surname")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled("lname", values?.disabledConfiguration))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="fname_afora"
                  required
                  margin="normal"
                  label={t("Name")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled("fname", values?.disabledConfiguration))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="afm_afora"
                  required
                  margin="normal"
                  disabled={disableAll || forMe}
                  label={t("AFM")}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrSelectBox
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled("gender", values?.disabledConfiguration))
                  }
                  name="gender_afora"
                  label={t("Gender")}
                  options={translatedGender || []}
                  optionlabel="dscr"
                  defaultoptiontext={t("Choose Here")}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="nationality_afora"
                  margin="normal"
                  label={t("Nationality")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "nationality",
                        values?.disabledConfiguration
                      ))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="ind_nr_afora"
                  margin="normal"
                  label={t("ADT")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled("ind_nr", values?.disabledConfiguration))
                  }
                  hint={forMe ? t("Wrong_ADT") : ""}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="amka_afora"
                  margin="normal"
                  label={t("AMKA")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled("amka", values?.disabledConfiguration))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  variant="outlined"
                  name="meth_afora"
                  margin="normal"
                  label={t("Meth")}
                  disabled={checkNewNautical() || disableAll}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="fath_lname_afora"
                  margin="normal"
                  label={t("Father Surname")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "fath_lname",
                        values?.disabledConfiguration
                      ))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="fath_fname_afora"
                  margin="normal"
                  label={t("Father Name")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "fath_fname",
                        values?.disabledConfiguration
                      ))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="moth_lname_afora"
                  margin="normal"
                  label={t("Mother Surname")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "moth_lname",
                        values?.disabledConfiguration
                      ))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="moth_fname_afora"
                  margin="normal"
                  label={t("Mother Name")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "moth_fname",
                        values?.disabledConfiguration
                      ))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrDate
                  required
                  name="dt_birth_afora"
                  label={t("Date of birth")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "dt_birth",
                        values?.disabledConfiguration
                      ))
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrSelectBox
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "birth_country",
                        values?.disabledConfiguration
                      ))
                  }
                  name="birth_country"
                  label={t("Birth Country")}
                  options={fetchBirthCountries || []}
                  optionlabel="dscr"
                  defaultoptiontext={t("Choose Here")}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              {values?.birth_country?.id !== GR_CODE_CRIMINAL && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    name="birth_city_not_greece"
                    margin="normal"
                    label={t("Birth City Abroad")}
                    disabled={disableAll}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrSelectBox
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "place_birth_id",
                        values?.disabledConfiguration
                      ))
                  }
                  name="place_birth_afora"
                  label={t("Place of birth")}
                  options={
                    PrfcsData?.sort((a, b) => (b.dscr < a.dscr ? 1 : -1)) || []
                  }
                  initialvalue={values.place_birth_afora}
                  optionlabel="dscr"
                  defaultoptiontext={t("Choose Here")}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrSelectBox
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "dimos_diamonis",
                        values?.disabledConfiguration
                      ))
                  }
                  name="dimos_diamonis_afora"
                  label={t("Place of staying")}
                  options={
                    PrfcsData?.sort((a, b) => (b.dscr < a.dscr ? 1 : -1)) || []
                  }
                  initialvalue={values.dimos_diamonis_afora}
                  optionlabel="dscr"
                  defaultoptiontext={t("Choose Here")}
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              {(values?.place_birth_afora?.id === ABROAD_BIRTH_PLACE_ID ||
                values?.place_birth_afora === ABROAD_BIRTH_PLACE_ID) && (
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                    <GovGrTextField
                      required
                      variant="outlined"
                      name="topos_eggrafis_dimotologiou_ellada"
                      margin="normal"
                      label={t("Place of registration in Greece")}
                      disabled={disableAll}
                      disabledmessage={t("Field can't be edited")}
                    />
                  </Grid>
                )}
              {checkNewNautical() && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrSelectBox
                    disabled={true}
                    name="epipedo_ekpaideusis_afora"
                    label={t("Education level")}
                    options={TranslatedEducationLevel || []}
                    optionlabel="dscr"
                    defaultoptiontext={t("Choose Here")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
              )}
              {checkNewNautical() && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrSelectBox
                    name="didacticYear"
                    label={t("Didactic Year")}
                    options={didacticyearWithOtherOption || []}
                    initialvalue={values.didactic_year}
                    optionlabel="dscr"
                    disabled={disableAll}
                    defaultoptiontext={t("Choose Here")}
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="address_afora"
                  margin="normal"
                  label={t("Address")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled("address", values?.disabledConfiguration))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="address_nr_afora"
                  margin="normal"
                  label={t("Address Number")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled(
                        "address_nr",
                        values?.disabledConfiguration
                      ))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="tk_afora"
                  margin="normal"
                  label={t("TK")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled("tk", values?.disabledConfiguration))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                <GovGrTextField
                  required
                  variant="outlined"
                  name="tel_afora"
                  margin="normal"
                  label={t("Phone Number")}
                  disabled={
                    disableAll ||
                    (forMe &&
                      isFieldDisabled("tel", values?.disabledConfiguration))
                  }
                  disabledmessage={t("Field can't be edited")}
                />
              </Grid>
              <Tooltip
                title={
                  forMe ? (
                    <Typography>
                      {t(
                        "In the case that information you see is not correct, please update your info"
                      )}
                    </Typography>
                  ) : (
                    ""
                  )
                }
                placement={"center-bottom"}
              >
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="mobile_afora"
                    margin="normal"
                    label={t("Mobile Phone Number")}
                    disabled={
                      disableAll ||
                      (forMe &&
                        isFieldDisabled(
                          "mobile",
                          values?.disabledConfiguration
                        ))
                    }
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
              </Tooltip>
              <Tooltip
                title={
                  forMe ? (
                    <Typography>
                      {t(
                        "In the case that information you see is not correct, please update your info"
                      )}
                    </Typography>
                  ) : (
                    ""
                  )
                }
                placement="center-bottom"
              >
                <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
                  <GovGrTextField
                    required
                    variant="outlined"
                    name="email_afora"
                    margin="normal"
                    label={t("Email")}
                    disabled={
                      disableAll ||
                      (forMe &&
                        isFieldDisabled("email", values?.disabledConfiguration))
                    }
                    disabledmessage={t("Field can't be edited")}
                  />
                </Grid>
              </Tooltip>
            </Grid>
            <CheckBoxesForCustomText
              applicationId={values?.appl_kind_id}
              disableAll={disableAll}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default ApplicantDetails;
